import { AxiosError, AxiosResponse } from "axios";
import { UseQueryOptions } from "react-query";
import { axiosPatientInstance } from "config";
import { useAxiosQuery } from "hooks";
import { AuditStatus } from "modules/audits/types";

type UseAuditStatusResponse = {
  id: string;
  demographicAuditStatus?: AuditStatus;
  providerChartAuditStatus?: AuditStatus;
  nurseChartAuditStatus?: AuditStatus;
  nurseChartAuditorId?: string;
  providerChartAuditorId?: string;
  providerId?: string | null;
  nurseId?: string | null;
};

function useAuditStatus(
  encounterId: string,
  options?: UseQueryOptions<AxiosResponse<UseAuditStatusResponse>, AxiosError>
) {
  return useAxiosQuery(
    ["audits-status", { encounterId }],
    () =>
      axiosPatientInstance.get<UseAuditStatusResponse>(
        `/v1/audits/${encounterId}/status`
      ),
    options
  );
}

export { useAuditStatus };
